<sbf-error-shell [errorNumber]="401" message1="ACCESS TO THIS RESOURCE IS DENIED" message2="KEEP EXPLORING"></sbf-error-shell>
